// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hf","loading":"hh","b":"hi","errorMsg":"hj","loadingMsg":"hk","successMsg":"hl","hideLoadingMsg":"hm","completed":"hn","a":"ho","kidsGreen":"hp"};